const GeneralInfoSkeleton = () => {
  return (
    <>
      <div className="firstSection">
        <div className="mediumItem">
          <div className="labelsSkeleton">Marca</div>
          <div className="inputSkeleton" />
        </div>

        <div className="smallItem">
          <div className="labelsSkeleton">Perfil</div>

          <div className="inputSkeleton" />
        </div>
        <div className="smallItem">
          <div className="labelsSkeleton">Gama</div>
          <div className="inputSkeleton" />
        </div>
        <div className="smallItem noMargin">
          <div className="labelsSkeleton">Garantia (opcional)</div>
          <div className="inputSkeleton" />
        </div>
      </div>
      <div className="secondSection">
        <div className="bigItem">
          <div className="labelsSkeleton">Descripción</div>
          <div className="inputSkeleton" />
        </div>
        <div className="bigItem noMargin">
          <div className="labelsSkeleton">Descripción</div>
          <div className="inputSkeleton" />
        </div>
      </div>
    </>
  );
};
export default GeneralInfoSkeleton;
